module.exports = __webpack_public_path__ + "img/SirenaComando.b684266a.svg";